import * as React from 'react';
import { Label } from '@/components/ui/label';

export function Field({
  label,
  error,
  required,
  hint,
  children,
}: {
  label: string;
  error?: string | undefined;
  required?: boolean;
  hint?: React.ReactNode;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-1.5">
      <Label>
        {label}
        {required ? (
          <span className="ml-0.5 text-[hsl(var(--destructive))]" title="Required">
            *<span className="sr-only"> (required)</span>
          </span>
        ) : null}
      </Label>
      {children}
      {error ? (
        <p className="text-xs text-[hsl(var(--destructive))]">{error}</p>
      ) : hint ? (
        <p className="text-xs text-[hsl(var(--muted-foreground))]">{hint}</p>
      ) : null}
    </div>
  );
}
